
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-monitoring/[type]",
      function () {
        return require("private-next-pages/content-monitoring/[type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-monitoring/[type]"])
      });
    }
  